import { TextInput } from "@jugl-web/ui-components/cross-platform";
import { useTranslations } from "@jugl-web/utils";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { InvoiceSettingsParams } from "@jugl-web/rest-api";

interface CityFieldProps {
  register: UseFormRegister<InvoiceSettingsParams>;
  errors: FieldErrors<InvoiceSettingsParams>;
  value: string;
}

const MAX_LENGTH = 100;

export const CityField = ({ register, errors, value }: CityFieldProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <TextInput
        placeholder={t({
          id: "common.enter",
          defaultMessage: "Enter",
        })}
        {...register("city", {
          maxLength: {
            value: MAX_LENGTH,
            message: `${value.length}/${MAX_LENGTH}`,
          },
          setValueAs: (inputValue) => inputValue.trim(),
        })}
        isInvalid={!!errors.city}
        label={t({
          id: "invoices.settings.businessInformation.city",
          defaultMessage: "City",
        })}
        errorMessage={errors.city?.message}
      />
    </div>
  );
};
